module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/TV1-5c373a7a8681fbcaa18ef7ace623f7b2.svg";